/**
 * Shared API error formatting for inventory views.
 */
export function formatInventoryError(error, fallback = "Request failed.") {
  if (!error) return fallback;
  if (typeof error === "string") return error;

  const data = error.response?.data;
  if (!data) {
    if (error.message === "Network Error") {
      return "Unable to reach the server. Check your connection and try again.";
    }
    return error.message || fallback;
  }

  if (data.errors && typeof data.errors === "object") {
    const messages = Object.values(data.errors).flat().filter(Boolean);
    if (messages.length) return messages.join(" ");
  }

  return data.message || fallback;
}

export function showInventoryError(error, title = "Error", fallback) {
  const message = formatInventoryError(error, fallback);
  toastr.error(message, title);
  return message;
}
